export const LOAD_USER_SUBSCRIPTION = 'LOAD_USER_SUBSCRIPTION';
export const SET_DEFAULT_USER_SUBSCRIPTION = 'SET_DEFAULT_USER_SUBSCRIPTION';
export const GET_ALL_SUBSCRIPTION_PLANS = 'GET_ALL_SUBSCRIPTION_PLANS';